module.exports = __webpack_public_path__ + "img/restitution-stockage.bc59b13e.png";